import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileItem } from 'ng2-file-upload';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { NewNote } from './new-note';
import { Note } from './note';
import { NoteResponse } from '../models/responses';
import { Reminder } from '../../core/components/reminders/models/models';

@Injectable()
export class NotesService {

  constructor(public httpClient: HttpClient) { }

  getNotesByRecordId(recordId, tableName): Observable<NoteResponse[]> {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes?companyId=${recordId}&tableName=${tableName}`;
    return this.httpClient.get<NoteResponse[]>(url);
  }

  getNotesByFilter(startDate, endDate): Observable<Note[]> {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/getNotesByFilter?startDate=${startDate}&endDate=${endDate}`;
    return this.httpClient.get<Note[]>(url);
  }

  getTableNamesInNotes() {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/getTableNamesInNotes`;
    return this.httpClient.get<any[]>(url);
  }

  saveNote(note: NewNote) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes`;
    return this.httpClient.post<Note>(url, note)
  }

  pinNote(noteId: number, isPinned:Boolean) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/pinNote`;
    return this.httpClient.patch<Note>(url, {noteId,isPinned})
  }

  hideNote(noteId: number) {
    const isVisible=false;
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/hideNote`;
    return this.httpClient.patch<NoteResponse>(url, {noteId,isVisible})
  }

  getNoteTypes(){
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/noteTypes`;
    return this.httpClient.get<any[]>(url);
  }

  changePriority(noteId: number, priority:number) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/changePriority`;
    return this.httpClient.patch<Note>(url, {noteId,priority})
  }

  getNoteById(noteId): Observable<Note[]> {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/${noteId}`;
    return this.httpClient.get<Note[]>(url);
  }
  searchForNote(recordId, tableName, noteTypeId): Observable<Note[]> {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/Search?recordId=${recordId}&tableName=${tableName}&noteTypeId=${noteTypeId}`;
    return this.httpClient.get<Note[]>(url);
  }

  changeText(noteId: number, text:string) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/changeText`;
    return this.httpClient.patch<Note>(url, {Id: noteId,StringData:  text})
  }

  updateNote(noteId:number,noteText:string,priority:number,isPinned:boolean) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/editNote`;
    return this.httpClient.patch<Note>(url, {Id: noteId, StringData: noteText, IsPinned:isPinned, Priority:priority})
  }

  getCompanyReminders(companyId: number): Observable<Reminder[]> {
    const url = `${environment.dotNetApiUrl}/${Area.core}/reminders/CompanyReminders?companyId=${companyId}`;
    return this.httpClient.get<Reminder[]>(url);
  }

  getUserActivityHistory(startDate: string, endDate: string, userId?: number): Observable<Note[]> {
    let url = `${environment.dotNetApiUrl}/${Area.transportation}/notes/UserActivity/History?startDate=${startDate}&endDate=${endDate}`;
    if (userId) {
      url += `&userId=${userId}`;
    }
    return this.httpClient.get<Note[]>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/notes/notes.service.ts